export const trackEvents = (response, email) => {
  console.log('Track Events Response:', response);
  // Facebook Events
  window?.fbevents && window?.fbq?.('track', 'Lead');
  window?.send_client_app_events && window?.sendAppEvent('track', 'Lead');

  // The server-side generate_lead (with the generated coupon) is fired by
  // LeadFinalizerWorker and triggers the Braze coupon email. Sailthru has
  // been replaced by Braze, so no Sailthru calls are made from this flow.

  // GTM & Rudderstack
  if (window?.promotion) {
    window?.claimPromotionGtmEvent(window.promotion, response);

    window?.generateLeadRudderstackEvent?.('Claim', response.lead, response.coupon, response.prefix);
  }
};
